  <div class="header-container">
    <div class="logo-container">
      <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
        <nb-icon icon="menu-2-outline"></nb-icon>
      </a>
      <a class="logo" href="#" (click)="navigateHome()"><img src="../../../../assets/images/logo.png" style="width: 40%;"></a>
    </div>
    <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
      <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
    </nb-select> -->
  </div>

  <div class="header-container">
    <nb-actions size="small" >
      <nb-action (click)="openChat()" class="chat-header-icon" *ngIf="_apiService.can('can_chat')">
      <nb-icon icon="message-circle-outline"></nb-icon>
      <span *ngIf="hasUnreadMessage" class="chat-notification-dot"></span>
    </nb-action>
      <nb-action class="user-action" nbPopoverTrigger="click" [nbPopover]="userMenuTemplate" nbPopoverPlacement="bottom-end">
        <nb-user
          [onlyPicture]="userPictureOnly"
          [name]="user?.fullName"
          [picture]="user?.profileImageUrl">
        </nb-user>
      </nb-action>
    </nb-actions>

    <ng-template #userMenuTemplate>
      <nb-card class="menu-card" style="min-width: 150px;margin: 0;">
        <nb-list>
        
          <nb-list-item routerLink="/auth/logout">Logout</nb-list-item>
        </nb-list>
      </nb-card>
    </ng-template>
  </div>

